global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';

import Headroom from "headroom.js";

import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";
import { Draggable } from "gsap/Draggable";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

/* Libreria per lo smoothscroll */
import Lenis from 'lenis';

/* Libreria per lo smoothscroll */
import lottie from 'lottie-web';

import fslightbox from "fslightbox";
import 'select2';                       // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';

$(document).ready(function() {

    gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, SplitText, CustomEase, Draggable, ScrollToPlugin);

    AOS.init({
        delay: 400,
        duration: 800,
        once: true,
    });

    function getDeviceType() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isTouchDevice = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
        const screenWidth = window.innerWidth;

        const isTablet = /ipad|android(?!.*mobile)|tablet|playbook|silk|kindle/i.test(userAgent) ||
            (screenWidth >= 600 && screenWidth <= 1280 && isTouchDevice);

        const isMobile = /iphone|ipod|android.*mobile|windows phone|blackberry/i.test(userAgent) ||
            (screenWidth < 600 && isTouchDevice);

        if (isTablet) {
            return "tablet";
        }

        if (isMobile) {
            return "mobile";
        }

        return "desktop";
    }

    const device = getDeviceType();

    const headerOverlay = $('.header__overlay');
    const closerX = $('#closerX-box');
    // sticky scroll menu
    const header = $('header');
    let offSet = $('#slideSectionHome').innerHeight()
    let fromTop = ($(window).scrollTop())

    window.onresize = function() {
        offSet = $('#slideSectionHome').innerHeight()
        setHead()
    }
    setHead()
    function setHead(){
        if (header.attr('data-type') === 'header--home') {
            if (fromTop >= offSet){
                header.removeClass(header.attr('data-type'));
            } else {
                header.addClass(header.attr('data-type'));
            }
            window.onscroll = function () {
                fromTop = ($(window).scrollTop())
                if (fromTop >= offSet){
                    header.removeClass(header.attr('data-type'));
                    header.addClass('header--std');
                } else {
                    header.addClass(header.attr('data-type'));
                    header.removeClass('header--std');
                }
            };
        } else {
            header.addClass('header--std');
        }
    }

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    headerOverlay.click(function (e) {
        // toggleSubMenu($('.nav-wrapper-brand'));
        toggleMenuOpenClose($('.header__nav-wrapper'));
    })

    closerX.click(function (e) {
        toggleMenuOpenClose($('.header__nav-wrapper'));
    })
    let body = $('body');
    // burger menu effect button
    let burgerButton = $('.burger-button');

    /* timeline per la discesa del menu */
    let timeline_nav = gsap.timeline({paused: true, reversed: true});
    timeline_nav.fromTo(
        ".header__nav-wrapper",
        {
            height: 0
        },
        {
            height: () => {
                const el = document.querySelector(".header__nav-wrapper");
                return el.scrollHeight + 80; // altezza reale + 50px
            },
            ease: CustomEase.create(
                "custom",
                "M0,0 C0.126,0.382 0.32,0.628 0.478,0.776 0.67,0.956 0.818,1.001 1,1"
            ),
            duration: 0.4
        }
    );

    /* timeline per gestire la comparsa delle voci del menu. la comparsa è volutamente insieme */
    let timeline_navItem = gsap.timeline({paused: true, reversed: true});
    timeline_navItem.from(".fake-border",  {
        duration: 0.7,
        width: 0,
        ease: "power4.inOut",
    }).from(".menu-text",  {
        duration: 0.6,
        yPercent: 125,
        ease: "power4.inOut",
    },"-=0.4").to(".nav-split", {
        overflow: "visible"
    });

    /* timeline per gestire la comparsa delle voci del menu. la comparsa è volutamente insieme */
    let timeline_navItemDX = gsap.timeline({paused: true, reversed: true});
    timeline_navItemDX.from(".fake-li .fake-border",  {
        duration: 0.7,
        width: 0,
        ease: "power4.inOut",
    });

    burgerButton.on('click', function(e) {
        e.preventDefault();
        toggleMenuOpenClose($('.header__nav-wrapper'));
    });

    function toggleMenuOpenClose(headerNavWrapper) {
        if (headerNavWrapper.hasClass('open')) {
            if (device != "mobile") {
                body.removeClass('no-scroll-y');
            }

            headerNavWrapper.removeClass('open');
            timeline_nav.reversed(!timeline_nav.reversed());
            timeline_navItem.reversed(!timeline_navItem.reversed())
            headerOverlay.removeClass('open');
            lenis.start()
        } else {
            if (device != "mobile") {
                body.addClass('no-scroll-y');
            }

            lenis.stop()
            headerNavWrapper.addClass('open');
            timeline_nav.play();
            timeline_navItem.play();
            headerOverlay.addClass('open');
        }
    }

    let brandButton = $('.link-brand');
    let subBrand = $('.nav-wrapper-brand');
    let prodButton = $('.link-products')
    let subProducts = $('.nav-wrapper-products');
    let contactsButton = $('.link-contacts');
    let subContacts = $('.nav-wrapper-contacts');
    let searchButton = $('.link-search');
    let subSearch = $('.nav-wrapper-search');

    if($(window).width() >= 1200) {
        subBrand.on('mouseenter', function() {
            hoverOpen(subBrand)
        }).on('mouseleave', function () {
            hoverClose(subBrand)
        });

        brandButton.on('mouseenter', function() {
            hoverOpen(subBrand)
        }).on('mouseleave', function () {
            hoverClose(subBrand)
        });

        subProducts.on('mouseenter', function() {
            hoverOpen(subProducts)
        }).on('mouseleave', function () {
            hoverClose(subProducts)
        });

        prodButton.on('mouseenter', function() {
            hoverOpen(subProducts)
        }).on('mouseleave', function () {
            hoverClose(subProducts)
        });

        subContacts.on('mouseenter', function() {
            hoverOpen(subContacts)
        }).on('mouseleave', function () {
            hoverClose(subContacts)
        });

        contactsButton.on('mouseenter', function() {
            hoverOpen(subContacts)
        }).on('mouseleave', function () {
            hoverClose(subContacts)
        });

        subSearch.on('mouseenter', function() {
            hoverOpen(subSearch)
        }).on('mouseleave', function () {
            hoverClose(subSearch)
        });

        searchButton.on('mouseenter', function() {
            hoverOpen(subSearch)
        }).on('mouseleave', function () {
            hoverClose(subSearch)
        });
    } else {

        let subBtnMenu = $('.header__item-has-submenu span:first-child');


        subBtnMenu.on('click', function (e) {
            e.preventDefault();
            /**
             * Avendo aggiunto un div in più per le animazioni in GSAP, viene cambiato il codice di recupero del "genitore":
             DA $(this).parent('.header__item-has-submenu') ovvero il padre di $(this)
             A $(this).parents(':eq(1)') ovvero il nonno di $(this) */
            /*if ($(this).parents(':eq(1)').hasClass('open')){
                $(this).parents(':eq(1)').removeClass('open');
                $(this).parents(':eq(1)').children('.header__nav-submenu-wrapper').slideUp( 400, function(){
                    $(this).parents(':eq(1)').find(".fake-border").show();
                });
            } else {
                $(this).parents(':eq(1)').find(".fake-border").hide();
                $(this).parents(':eq(1)').addClass('open');
                $(this).parents(':eq(1)').children('.header__nav-submenu-wrapper').slideDown();
            }*/

            const parentMenuItem = $(this).parents('.header__item-has-submenu');
            const subMenu = parentMenuItem.children('.header__nav-submenu-wrapper');

            if (parentMenuItem.hasClass('open')) {
                parentMenuItem.removeClass('open');
                subMenu.slideUp(400, function () {
                    parentMenuItem.find(".fake-border").show();
                });
            } else {
                $('.header__item-has-submenu.open').not(parentMenuItem).each(function() {
                    $(this).removeClass('open');
                    $(this).children('.header__nav-submenu-wrapper').slideUp(400);
                    $(this).find(".fake-border").show();
                });
                parentMenuItem.find(".fake-border").hide();
                parentMenuItem.addClass('open');
                subMenu.slideDown(400);
            }
        });
    }

    // Request per la ricerca del prodotto
    let inputFilterProd = $("#searchProdMenu");
    inputFilterProd.keyup(function () {
        let valueInput = $(this).val();
        if(valueInput !== ""){
            if (valueInput.length >= 2){
                $.request("searchProduct::onSearchProduct", {
                    data: { data: valueInput },
                    complete: function() {

                    }
                });
            }else{
                $('#resultSearch').empty();
            }
        }
    });

    function hoverOpen(sub) {
        lenis.stop()
        sub.addClass('open');
        sub.stop().slideDown();
        if ($('.page-home')[0]){
            if (!header.hasClass('header--std')){
                if (header.hasClass('header--home') && header.data('type') === 'header--home' ){
                    header.stop().removeClass('header--home')
                } else {
                    header.stop().addClass('header--home')
                }
            }
        }
        headerOverlay.stop().addClass('open');
    }

    function hoverClose(sub) {
        sub.removeClass('open');
        sub.stop().slideUp();
        lenis.start()
        if ($('.page-home')[0]){
            if (!header.hasClass('header--std')){
                if (header.hasClass('header--home')){
                    header.stop().removeClass('header--home')
                }else {
                    header.stop().addClass('header--home')
                }
            }
        }
        headerOverlay.stop().removeClass('open');
    }

    headerOverlay.on('click', function () {
        headerOverlay.removeClass('open')
        $('.header__nav-wrapper').removeClass('open');
        lenis.start()
    })


    // To-top button
    const toTopBtn = $('#to-top-filter');

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });



// MODIFICHE SLIDE CENTRALE
    $(".midsliders-container-item").each(function () {
        $(this)
            .on("mouseover", function () {
                $(".midsliders-container").addClass("hover");
                $(this).addClass("active");
            })
            .on("mouseleave", function () {
                $(".midsliders-container-item").removeClass("active");
            });
    });



    /* inizio hover cerchio progetti */

    /* serve per caricare gli effetti quando pagino gli elementi che hanno bisogno di riavere il js anche se è presente nel main.js */
    addEventListener('ajax:update-complete', function(event) {
        hoverProjects();
        loadEffectAjax();
    });

    function myGetTotalLength(circle) {
        const r = parseFloat(circle.attr('r'));
        return 2 * Math.PI * r;
    }

    function hoverProjects() {

        let circleList = $('.icon-circle circle');
        let projectsList = $('.project');

        circleList.each(function () {
            //non posso usare getTotalLength nativa di js. Tira un errore js su chrome mobile perchè non riesce a calcolare la length totale
            //di un elemento "nascosto" (via css c'è opacity 0 al contentiore .project)
            //creo la mia funzione e fine.
            const length = myGetTotalLength($(this));
            gsap.set($(this), { strokeDasharray: length, strokeDashoffset: length });
        });

        projectsList.each(function () {
            const current_circle = $(this).find(".icon-circle circle");
            const length = myGetTotalLength(current_circle);

            let tl = gsap.timeline({ paused: true });
            $(this).data("circleTimeline", tl);

            $(this).on('mouseenter touchstart', () => {
                let tl = $(this).data("circleTimeline");
                tl.kill();
                tl = gsap.timeline();
                tl.to(current_circle, {
                    strokeDashoffset: 0,
                    duration: 1,
                    ease: "power1.out"
                });
                $(this).data("circleTimeline", tl);
            });

            $(this).on('mouseleave touchend', () => {
                let tl = $(this).data("circleTimeline");
                tl.kill();
                tl = gsap.timeline();
                tl.to(current_circle, {
                    strokeDashoffset: length,
                    duration: 0.4,
                    ease: "power1.in"
                });
                $(this).data("circleTimeline", tl);
            });
        });

    }


    if ($(".project").length > 0 ) {
        hoverProjects();
    }

    /* fine hover cerhio progetti */

    if ($(window).innerWidth >= "768"){
        if ($('.page-products .eventFilter').length > 0 || $('.page-products_ambiente .eventFilter').length > 0 || $('.page-products_typology .eventFilter').length > 0 || $('.page-products_brand .eventFilter').length > 0) {
            let fixmeTop = $('#eventFilter').offset().top ;
            $(window).scroll(function() {
                let currentScroll = $(window).scrollTop();
                if (currentScroll >= fixmeTop) {
                    $('#eventFilter').css({
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        'box-shadow': '0px 2px 10px rgba(147, 147, 147, 1)'
                    });
                    $('#eventFilter').addClass("py-0").removeClass("py-5");
                } else {
                    $('#eventFilter').css({
                        position: 'static',
                        'box-shadow': 'unset'
                    });
                    $('#eventFilter').addClass("py-5").removeClass("py-0");
                }
            });
        }
    }

    /* questo codice anima l'svg della home per MILANI50 */
    if ($('.seleziona path').length > 0 ) {
        gsap.set('.seleziona path', {opacity:1});

        gsap.from('.seleziona path', {
            drawSVG: 0,
            duration: 3,
            opacity: 1
        });
    }

    if ($('.alter path').length > 0 ) {
        gsap.set('.alter path', {opacity:1});
        gsap.from('.alter path', {
            drawSVG: 0,
            duration: 3,
            opacity: 1,
            scrollTrigger: {
                trigger: '.alter path',
                start: "top center",
            }
        });
    }
    /* fine svg animation MILANI50 */


    // gsap.from('.seleziona_2 path', {
    //     drawSVG: "0%",
    //     duration: 1,
    //     // opacity: 1
    // }).to('.seleziona_2 path', {
    //     drawSVG: "100%",
    //     duration: 1,
    //     // opacity: 1
    // });

    $('.filter-btn-select').select2({
        minimumResultsForSearch: Infinity,
    });

    $('.brandFilterProd').select2({
        minimumResultsForSearch: Infinity,
        templateResult: formatState,
        templateSelection: formatState,
    });

    $('#raggio_km').select2({
        minimumResultsForSearch: Infinity,
    });

    function formatState(state) {
        if (!state.id) { return state.text; }
        let $state = $(`<div class="d-flex align-items-center"><span class="me-3 brand-${state.text.toLowerCase().trim()}"></span> ${state.text} </div>`);
        return $state;
    }

    $('b[role="presentation"]').hide();
    $('.select2-selection__arrow').addClass('d-flex align-items-center me-2')
    $('.select2-selection__arrow').append('<i class="fa fa-angle-down"></i>');


    function addHeadingEffect(item) {
        if (item.length > 0) {
            item.addClass("heading-effect");
        }
    }

    function addContentEffect(item) {
        if (item.length > 0) {
            item.addClass("content");
        }
    }

    if ($('.active_content_editor').length > 0) {
        addHeadingEffect($(".animation-tinyMCE:not(.mce-content-body) h1"));
        addHeadingEffect($(".animation-tinyMCE:not(.mce-content-body) h2"));
        addHeadingEffect($(".animation-tinyMCE:not(.mce-content-body) h3"));

        addContentEffect($(".animation-tinyMCE:not(.mce-content-body) h4"));
        addContentEffect($(".animation-tinyMCE:not(.mce-content-body) h5"));
        addContentEffect($(".animation-tinyMCE:not(.mce-content-body) h6"));
        addContentEffect($(".animation-tinyMCE:not(.mce-content-body) div"));

        /* aggiungo alla descrizione della singola timeline l'effetto */
        addContentEffect($(".section-single-time .content-effect p"));
        /* animazioni per titoli */
        const headingEffect = document.querySelectorAll(".heading-effect"); //classe per animare gli H1, H2..
        const content = document.querySelectorAll(".content"); //classe per animare il testo

        /* animazione per gli header */
        if (headingEffect.length > 0){

            headingEffect.forEach((target) => {
                target.style.opacity = 1;
                let words = new SplitText( target, { type: 'words'});

                gsap.from(words.words, {
                    autoAlpha: 0,
                    y: 70,
                    stagger: 0.035,
                    ease: "power2.out",
                    duration: 1.1,
                    visibility:"hidden",
                    scrollTrigger: {
                        trigger: target,
                        start: "top 80%",
                    }
                });
            });
        }

        /* animazione per il testo */
        if (content.length > 0){
            content.forEach((target) => {
                target.style.opacity = 1;
                let lines = new SplitText( target, { type: 'lines' });
                gsap.from(lines.lines, {
                    opacity: 0,
                    y: 100,
                    skewY: 2.5,
                    stagger: 0.05,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: target,
                        start: "top 70%",
                    }
                });
            });
        }
    } else {
        /* avendo impostato l'opacità a zero via css per evitare il fouc, devo impostare opacity a 1 quando sto facendo dataentry */
        const headingEffect = document.querySelectorAll(".heading-effect"); //classe per animare gli H1, H2..
        const content = document.querySelectorAll(".content"); //classe per animare il testo

        /* animazione per gli header */
        if (headingEffect.length > 0) {

            headingEffect.forEach((target) => {
                target.style.opacity = 1;
            });
        }

        if (content.length > 0) {

            content.forEach((target) => {
                target.style.opacity = 1;
            });
        }
    }



    if ($(".section-hero-animation").length > 0) {
        /* setto in js il rettangolo perchè in css mi fa il fouc */
        gsap.set(".polygon-clip-path", {
            "clip-path": "polygon(0% 0%, 0% 100%, 0 100%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%, 100% 100%, 100% 0%)"
        });

        gsap.from(".polygon-clip-path", {
            "clip-path": "polygon(0% 0%, 0% 100%, 10% 100%, 10% 10%, 90% 10%, 90% 90%, 10% 90%, 10% 100%, 100% 100%, 100% 0%)",
            scrollTrigger: {
                trigger: ".section-hero-animation",
                start: "top top", // when the top of the trigger hits the top of the viewport
                end: "bottom bottom", // bottom of the trigger hits the bottom of the vp
                scrub: true,
                markers: false
            }
        });

        gsap.to(".arrow-down", {
            opacity: 0,
            scrollTrigger: {
                trigger: ".section-hero-animation",
                start: "top top", // when the top of the trigger hits the top of the viewport
                end: "+=200", // scroll 150px down
                scrub: true
            }
        });
    }

    /* libreria per fare lo smoothscroll. non dovrebbe dar fastidio con le altre librerie */
    const lenis = new Lenis({
        autoRaf: true,
        smooth: true,
        lerp: 0.1
    });
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.lagSmoothing(0);
    /* fine smoothscroll */

    let xInit;
    function animateGalleryProject(list_images, single_image_class, scoller_trigger, direction = "left") {

        if (list_images.length > 0){
            list_images.each(function(index) {
                let image_box =  $(this).find(single_image_class);

                if (direction == "right" && index % 2 == 0 ) {
                    xInit = "100%";
                } else {
                    xInit = "-100%";
                }

                gsap.timeline({
                    scrollTrigger: {
                        trigger: $(this),
                        scroller: scoller_trigger,
                        start: "top 70%"
                    }
                }).from(image_box.find("img"), {
                        x: xInit,
                        duration: 1.35,
                        opacity: 0,
                        stagger: 0.65,
                        ease: "power3.inOut",
                        zIndex:-1
                    });
            });
        }
    }
    /* animazione d'ingresso delle immagini dei progetti: sezione due immagini affiancate e singola immagine*/
    if ( $(".section-with-image").length > 0) {
        let list_images = $(".section-with-image");
        animateGalleryProject(list_images, ".section-single-image", ".page-project");
    }

    /* animazione masonry progetti */
    if ( $(".gallery-project").length > 0) {
        let list_images = $(".gallery-project");
        animateGalleryProject(list_images, ".gallery-image", ".page-project");
    }

    /* animazione immagine single timeline */
    if ( $(".section-single-time").length > 0) {
        let list_images = $(".section-single-time");
        animateGalleryProject(list_images, ".section__image", ".page-company_our-story", "right");
    }


    /* zoom al caricamento della lista dei progetti */

    function loadEffectAjax() {
        const elements = $(".zoom-in-project");
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    $(entry.target).addClass("zoom-in-active");
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.8 });

        elements.each(function () {
            observer.observe(this);
        });
    }
    loadEffectAjax();

    /* fine zoom */


    /* anima il cerchio messo nella hero della pagina lista progetti */
    /* deprecato perchè non c'è più l'ancora che ti porta in basso*/
    $(".hero-column .icon-circle").on('mouseenter touchstart', () => {
        gsap.to($(this).find("circle"), {
            strokeDashoffset: 0,
            duration: 1,
            ease: "power1.out"
        });
    }).on('mouseleave touchend', () => {
        gsap.to($(this).find("circle"), {
            strokeDashoffset: $(this).find("circle").get(0).getTotalLength(),
            duration: 1,
            ease: "power1.out"
        });
    }).on("click", function(){
        var top = document.getElementById("circle_anchor").offsetTop;
        window.scrollTo(0, top);
    });

    /* clippath/maschera sul video dei brand. Questa è una evoluzione di quella nei progetti. */
    if ($(".video-wrapper").length > 0) {
        const tlClipPath = gsap.timeline({
            reversed: true,
            paused: true,
            scrollTrigger: {
                trigger: ".triggera-clipath",
                start: "top top",
                toggleActions: "play none reverse none"
            }
        });

        tlClipPath.to(".video-wrapper", {
            clipPath: "inset(0%)",
            duration: 1.5,
            ease: "power2.out"
        });
    }

    /* MILANI: in questo modo carico un solo video a seconda del dispositivo e quindi la pagina pesa di meno */
    const videoMilani = document.getElementById("milaniVideo");
    if (videoMilani) {
        const sourceMilani = document.createElement("source");
        sourceMilani.src = device == "mobile" ? "/themes/milani/assets/images/video-brand/Milani_mobile.mp4" : "/themes/milani/assets/images/video-brand/Milani_desktop.mp4";
        sourceMilani.type = "video/mp4";
        videoMilani.appendChild(sourceMilani);
        videoMilani.load();
    }



    /* SEM: in questo modo carico un solo video a seconda del dispositivo e quindi la pagina pesa di meno */
    const videoSEM = document.getElementById("semVideo");
    if (videoSEM) {
        const sourceSEM = document.createElement("source");
        sourceSEM.src = device == "mobile" ? "/themes/milani/assets/images/video-brand/SEM_mobile.mp4" : "/themes/milani/assets/images/video-brand/SEM_desktop.mp4";
        sourceSEM.type = "video/mp4";
        videoSEM.appendChild(sourceSEM);
        videoSEM.load();
    }

    /* SPAZIO Milani: in questo modo carico un solo video a seconda del dispositivo e quindi la pagina pesa di meno */
    const videoSpazioMilani = document.getElementById("spazioMilaniVideo");
    if (videoSpazioMilani) {
        const sourceSpazioMilani = document.createElement("source");
        sourceSpazioMilani.src = device == "mobile" ? "/themes/milani/assets/images/video-brand/SpazioMILANI_mobile.mp4" : "/themes/milani/assets/images/video-brand/SpazioMILANI_desktop.mp4";
        sourceSpazioMilani.type = "video/mp4";
        videoSpazioMilani.appendChild(sourceSpazioMilani );
        videoSpazioMilani.load();
    }

    /* GESTIONE SLIDER */

    const type_easing = 'linear';
    const duration_animate = 9000;
    const progressBarTime = '9s';
    const progressBarPrevTime = 450 / 1000;
    const spaceBetweenSlider = 30;
    const maxProgressBar = '100%';
    const normalTitleColor = 'rgba(118, 118, 118, 1)';
    const maxScale = 1.2;
    const durationBg = 10;
    const opacityBg = 0;
    let progressBar, activeImage, contentBox, slideTitle, boxButton, slideText, firstImage;


    if (device == "mobile") {
        firstImage = document.querySelector('.swiperHomeMain .swiper-slide img.for-mobile');
        if (firstImage == null) { //UFF
            firstImage = document.querySelector('.swiperHomeMain .swiper-slide img.for-desktop');
        }
    } else {
        firstImage = document.querySelector('.swiperHomeMain .swiper-slide img.for-desktop');
    }

    const progressBars = document.querySelectorAll('.progress-bar-inner');

    /* reset della progress bar in modo che ci sia l'effetto di "torna indietro" della bar */
    const resetProgressBars = (duration) => {
        progressBars.forEach(bar => {
            bar.style.width = '100%';
            bar.style.transitionDuration = `${duration}s`;
            bar.style.width = '0%';
            bar.style.transitionTimingFunction = 'easeInOutExpo';
        });
    };

    /* fa partire il caricamento della bar */
    const setProgressBar = (bar, duration) => {
        bar.style.transitionDuration = duration;
        bar.style.width = maxProgressBar;
        bar.style.transitionTimingFunction = 'easeInOutExpo';
    };

    /* cambia il colore dei titoli delle 4 voci, in modo da fare un reset ogni volta che si passa da una slide all'altra */
    const changeSlideTitleColor = (color) => {
        document.querySelectorAll('.slide-title').forEach(title => {
            title.style.color = color;
        });
    };

    /* esegue l'effetto di zoom all'immagine di sfondo dello slide */
    const animateImage = (image, scale, duration) => {
        let tlImage = gsap.timeline();
        tlImage.to(image, {
            scale: scale,
            opacity: 1,
            duration: duration / 1000,
            ease: type_easing,
            force3D: true,
        });

        tlImage.to(image, {
            scale: 1.05,
            duration: progressBarPrevTime,
            ease: type_easing,
            force3D: true,
        });
    };

    /* fa un fade in dal bottom del box dello slide */
    const animateBox = (box) => {
        let tlBox = gsap.timeline();

        tlBox.set(box, { y: "35%" });
        tlBox.to(box, {
            opacity: 1,
            y: "0%",
            duration: 1.3,
            ease: 'easeOutQuad',
            force3D: true,
        });
    };


    const animateBoxBrand = (box) => {
        let tlBoxBrand = gsap.timeline();
        box.style = null;
        // tlBoxBrand.set(box, { clearProps: "all" });
        tlBoxBrand.set(box, {
            opacity: 1,
            y: "-20%",
            duration: 1.4,
            ease: 'easeOutQuad',
            force3D: true,
        });
    };



    const animateTextbrand = (text) => {
        let tlTextBrand = gsap.timeline();

        text.style = null;
        tlTextBrand.set(text, { clearProps: "all" });
        tlTextBrand.from(text, {
            opacity: 1,
            y: "50%",
            duration: 1.2,
            ease: 'easeOutQuad',
            force3D: true,
        });
    };

    const animateButton = (btn) => {
        let tlButton = gsap.timeline();
        tlButton.to(btn, {
            opacity: 1,
            duration: 0.1,
            ease: 'easeOutQuad',
            force3D: true,
        });
    };


    const swiperThumbHomeMain = new Swiper('.swiperThumbHomeMain', {
        spaceBetween: spaceBetweenSlider,
        slidesPerView: 4,
        slideToClickedSlide: true,
    });

    const swiperHomeMain = new Swiper('.swiperHomeMain', {
        spaceBetween: spaceBetweenSlider,
        slidesPerView: 1,
        loopedSlides: 4,
        loop: true,
        autoplay: {
            delay: duration_animate,
        },
        effect: "fade",
        thumbs: {
            swiper: swiperThumbHomeMain,
        },
        initialSlide: 0,
        on: {
            init: function () {
                animateImage(firstImage, maxScale, duration_animate);
                resetProgressBars(progressBarPrevTime);

                progressBar = swiperThumbHomeMain.slides[0].querySelector('.progress-bar-inner');
                setProgressBar(progressBar, progressBarTime);

                slideTitle = swiperThumbHomeMain.slides[0].querySelector('.slide-title');
                slideTitle.style.color = "white";
            },
            activeIndexChange: function () {
                if (device == "mobile") {
                    activeImage = this.slides[this.activeIndex].querySelector('img.for-mobile');
                    if (activeImage == null) { //meh
                        activeImage = this.slides[this.activeIndex].querySelector('img.for-desktop');
                    }
                } else {
                    activeImage = this.slides[this.activeIndex].querySelector('img.for-desktop');
                }

                animateImage(activeImage, maxScale, duration_animate);

                contentBox = this.slides[this.realIndex].querySelector('.swiperHomeMain .slide-descr');
                animateBox(contentBox);

                boxButton = this.slides[this.realIndex].querySelector('.swiperHomeMain .slide-button');
                animateButton(boxButton);
            },
            slideChangeTransitionStart: function () {
                changeSlideTitleColor(normalTitleColor);
                resetProgressBars(progressBarPrevTime);
            },
            slideChangeTransitionEnd: function () {
                const index_currentSlide = this.realIndex;
                swiperThumbHomeMain.slideTo(index_currentSlide, 1, false);

                slideTitle = swiperThumbHomeMain.slides[index_currentSlide].querySelector('.slide-title');
                slideTitle.style.color = "white";

                progressBar = swiperThumbHomeMain.slides[index_currentSlide].querySelector('.progress-bar-inner');
                setProgressBar(progressBar, progressBarTime);
            },
        }
    });
    /* FINE PRIMO SLIDER IN HOME PAGE */


    let firstImageMilani;
    if (device == "mobile") {
        firstImageMilani = document.querySelector('.swiperMilaniMain .swiper-slide img.for-mobile');
        if (firstImageMilani == null) { //UFF
            firstImageMilani = document.querySelector('.swiperMilaniMain .swiper-slide img.for-desktop');
        }
    } else {
        firstImageMilani = document.querySelector('.swiperMilaniMain .swiper-slide img.for-desktop');
    }
    swiperBrand('.swiperThumbMilaniMain', '.swiperMilaniMain', firstImageMilani);


    function swiperBrand(swiperThumb, swiperMain, firstImageBrand){

        const swiperThumbMilaniMain = new Swiper(swiperThumb, {
            spaceBetween: spaceBetweenSlider,
            slidesPerView: 4,
            slideToClickedSlide: true,
        });

        const swiperMilaniMain = new Swiper(swiperMain, {
            spaceBetween: spaceBetweenSlider,
            slidesPerView: 1,
            loopedSlides: 4,
            loop: true,
            autoplay: {
                delay: duration_animate,
            },
            effect: "fade",
            thumbs: {
                swiper: swiperThumbMilaniMain,
            },
            initialSlide: 0,
            on: {
                init: function () {
                    animateImage(firstImageBrand, maxScale, duration_animate);
                    resetProgressBars(progressBarPrevTime);

                    progressBar = swiperThumbMilaniMain.slides[0].querySelector('.progress-bar-inner');
                    setProgressBar(progressBar, progressBarTime);

                    slideTitle = swiperThumbMilaniMain.slides[0].querySelector('.slide-title');
                    slideTitle.style.color = "white";
                },
                activeIndexChange: function () {
                    if (device == "mobile") {
                        activeImage = this.slides[this.activeIndex].querySelector('img.for-mobile');

                        if (activeImage == null) {
                            activeImage = this.slides[this.activeIndex].querySelector('img.for-desktop');
                        }
                    } else {
                        activeImage = this.slides[this.activeIndex].querySelector('img.for-desktop');
                    }
                    animateImage(activeImage, maxScale, duration_animate);

                    contentBox = this.slides[this.realIndex].querySelector('.swiperMilaniMain .slide-box');
                    animateBoxBrand(contentBox);

                    slideText = this.slides[this.realIndex].querySelector('.swiperMilaniMain .slide-text');
                    animateTextbrand(slideText);
                },
                slideChangeTransitionStart: function () {
                    changeSlideTitleColor(normalTitleColor);
                    resetProgressBars(progressBarPrevTime);
                },
                slideChangeTransitionEnd: function () {
                    const index_currentSlide = this.realIndex;
                    swiperThumbMilaniMain.slideTo(index_currentSlide, 1, false);

                    slideTitle = swiperThumbMilaniMain.slides[index_currentSlide].querySelector('.slide-title');
                    slideTitle.style.color = "white";

                    progressBar = swiperThumbMilaniMain.slides[index_currentSlide].querySelector('.progress-bar-inner');
                    setProgressBar(progressBar, progressBarTime);
                },
            }
        });
    }

    /* Gestione TIMELINE pagina Our Story */
    if ($(".timeline-section")[0]) {

        const sections = gsap.utils.toArray('.section-single-time')
        const track = document.querySelector('[data-draggable]')
        const navLinks = gsap.utils.toArray('[data-link]')

        const lastItemWidth = () => navLinks[2].offsetWidth
        const getUseableHeight = () => document.documentElement.offsetHeight - window.innerHeight


        const getDraggableWidth = () => {
            const lastItem = navLinks[navLinks.length - 1];
            const trackRight = track.getBoundingClientRect().right;
            const lastRight = lastItem.getBoundingClientRect().right;
            return lastRight - track.getBoundingClientRect().left;
        }

        const updatePosition = () => {
            const left = track.getBoundingClientRect().left  * -1
            const width = getDraggableWidth()
            const useableHeight = getUseableHeight()
            const y = gsap.utils.mapRange(0, width, 0, useableHeight, left)

            st.scroll(y)
        }

        const tl = gsap.timeline();
        tl.to(track, {
            x: () => {
                return getDraggableWidth() * -1
            },
            ease: 'none'
        });


        const st = ScrollTrigger.create({
            animation: tl,
            scrub: 0,
            trigger: ".timeline-section",
            start: "top 15px",

        })


        const initSectionAnimation = () => {

            sections.forEach((section, index) => {
                /* Create the timeline */
                const sectionTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: () => 'top center',
                        end: () => `+=${window.innerHeight}`,
                        toggleActions: 'play reverse play reverse',
                        toggleClass: 'is-active',
                        onToggle: ({ isActive }) => {
                            const sectionLink = navLinks[index];

                            if (isActive) {
                                sectionLink.parentNode.classList.add("link-active");
                                sectionLink.classList.add('is-active')
                            } else {
                                sectionLink.parentNode.classList.remove("link-active");
                                sectionLink.classList.remove('is-active')
                            }
                        },
                    }
                })

                /* va escluso da mobile altrimenti le frecce prev/next non mettono correttamente la classe active */
                if (device != "mobile") {
                    /* Create a new timeline to add an active class to the nav link for the current section */
                    const sectionTl2 = gsap.timeline({
                        scrollTrigger: {
                            trigger: section,
                            start: 'top top',
                            end: () => `bottom top`,
                            toggleActions: 'play reverse play reverse',
                            toggleClass: 'is-active',
                            onToggle: ({ isActive }) => {
                                const sectionLink = navLinks[index]
                                if (isActive) {
                                    sectionLink.parentNode.classList.add("link-active");
                                    sectionLink.classList.add('is-active');
                                } else {
                                    sectionLink.parentNode.classList.remove("link-active");
                                    sectionLink.classList.remove('is-active')
                                }
                            }
                        }
                    })
                }
            })
        }

        initSectionAnimation()

        let prev_section, next_section;
        const durationTime = 700
        $("#timelineRowPrev").on("click", function (){
            if ($("li.link-active").length > 0) {
                // active_section = Number($(".nav__link.is-active").attr("href").replace("#section_","")) - 1;
                prev_section = $("li.link-active").prev().find(".nav__link").attr("href");
                prev_section = $(prev_section);

                if (prev_section.length > 0) {
                    $('html, body').animate({
                        scrollTop: prev_section.offset().top
                    }, 700, 'linear');
                }
            }

        });

        $("#timelineRowNext").on("click", function (){
            if ($("li.link-active").length > 0) {
                //active_section = Number($(".nav__link.is-active").attr("href").replace("#section_","")) + 1;
                next_section = $("li.link-active").next().find(".nav__link").attr("href");
                next_section = $(next_section);

                if (next_section.length > 0) {
                    $('html, body').animate({
                        scrollTop: next_section.offset().top
                    }, 700, 'linear');
                }
            }
        });

        if ($('#timelineRow').length > 0 ) {
            let fixmeTop = $('#timelineRow').offset().top;

            $(window).scroll(function() {
                let currentScroll = $(window).scrollTop();
                if (currentScroll >= fixmeTop) {
                    $('#timelineRow').css({
                        position: 'fixed',
                        top: '0',
                        left: '0',
                    });
                } else {
                    $('#timelineRow').css({
                        position: 'absolute',
                        top: '0',
                    });
                }

                /* con questo codice, quando arrivo a footer nascondo la timeline */
                let scrollBottom = $('footer').offset().top;
                if (scrollBottom - Number(currentScroll) < 800) {
                    $('#timelineRow').css({
                        position: 'absolute',
                        top: '0',
                    });
                }

                /* con questo codice, quando arrivo a footer nascondo la timeline */
                let timelineRow = $('#timelineRow').offset().top;
                console.log(timelineRow);
                if (timelineRow  < 1500) {
                    $('#arrow-storyUp').css({
                        opacity: 0,
                    });
                } else {
                    $('#arrow-storyUp').css({
                        opacity: 1,
                    });
                }
            });
        }
    }

    /*FINE TIMELINE*/

    /* freccia rotonda nelle hero cliccabile in questo modo */
    $("#arrow-projectSingle").on("click touchstart", function () {
        $('html, body').animate({
            scrollTop: $('#contentProjectSingle').offset().top - 150
        }, 1500);
    });

    if ($('#accordionDesigner').length > 0 || $("#accordionMateriali").length > 0 || $("#accordionExtra").length > 0){
        $('.accordion-collapse').on('shown.bs.collapse', function (e) {
            let $panel = $(this).closest('.accordion-item');
            $('html,body').animate({
                scrollTop: $panel.offset().top - 200
            }, 200);
        });
    }

    if ($('.download-area #accordion')){
        $(document).on('click', '.download-area #accordion .card-header', function () {
            if ($(this).hasClass('border-none')) {
                $(this).removeClass('border-none');
            } else {
                $(this).addClass('border-none');
            }
        });
    }

    /* scroll prevent filtri prodotto con libreria lenis */
    if ($('select').length > 0){
        $('select').on("select2:opening", function(e) {
            setTimeout(function () {
                const dropdown = document.querySelector('.select2-container--open .select2-dropdown');
                if (dropdown) {
                    dropdown.setAttribute('data-lenis-prevent', '');
                }
            }, 0);
        });
    }
});
